import {
    createSlice,
    PayloadAction,
    createAsyncThunk
  } from '@reduxjs/toolkit';
  import type { RootState } from 'app/store';
  import { postFormData } from 'utils/service';
  // declaring the types for our state
  export type DownloadState = {
    data: any;
    pending: boolean;
  };
  
  const initialState: DownloadState = {
    data: [],
    pending: false,
  };

  // This action is what we will call using the dispatch in order to trigger the API call.
  export const getDownloadData = createAsyncThunk('api/downloads', async () => {
    let data: any = { }
    let response: any = await postFormData('downloads', data);
    if (response.success === "true") {
      return response
    }
    return {};
  });
  
  export const downloadSlice = createSlice({
    name: 'downloads',
    initialState,
    reducers: {
    },

    extraReducers: builder => {
      builder
        .addCase(getDownloadData.pending, state => {
          state.pending = true;
        })
        .addCase(getDownloadData.fulfilled, (state, { payload }) => {
          state.pending = false;
          state.data = (payload.data) ? payload.data : [];
        });
    },

  });
  // Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
  export const {
   
  } = downloadSlice.actions;
  
  // calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
  export const selectDownload = (state: RootState) => state.downloads;
  
  // exporting the reducer here, as we need to add this to the store
  export default downloadSlice.reducer;